// Angular
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

// Third party
import { Observable } from 'rxjs';

// Local library
import { API } from '@amwager/util-ts';

// Local file
import { BASE_URL } from '../tokens';



@Injectable()
export class HttpService {

  private url!: string;
  get apiUrl(): string { return this.url; }
  set apiUrl(url: string) { this.url = url; }

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_URL) private readonly api: string,
  ) {
    this.apiUrl = this.api;
  }

  /**
   * @description
   * GET method API requests
   *
   * @param IHttpParams data
   * @returns Observable
   */
  get$<T>(data: API.IHttpParams): Observable<T> {
    return this.http.get<T>(
      this.getApiUrl(data),
      { params: data.params }
    );
  }

  /**
   * @description
   * POST method API requests
   *
   * @param IHttpParams data
   * @returns Observable
   */
  post$<T>(data: API.IHttpParams): Observable<T> {
    return this.http.post<T>(
      this.getApiUrl(data),
      data.body
    );
  }

  /**
   * @description
   * PUT method API requests
   *
   * @param IHttpParams data
   * @returns Observable
   */
  put$<T>(data: API.IHttpParams): Observable<T> {
    return this.http.put<T>(
      this.getApiUrl(data),
      data.body
    );
  }

  /**
   * @description
   * DELETE method API requests
   *
   * @param IHttpParams data
   * @returns Observable
   */
  delete$<T>(data: API.IHttpParams): Observable<T> {
    return this.http.delete<T>(
      this.getApiUrl(data),
      { params: data.params }
    );
  }

  /**
   * @description
   * Dynamic method API requests
   *
   * @param IHttpParams data
   * @returns Observable
   */
  request$<T>(data: API.IHttpParams): Observable<T> {
    return this.http.request<T>(
      data.method as string,
      this.getApiUrl(data),
      {
        body: data.body || '',
        params: data.params || ''
      }
    );
  }

  /**
   * @description
   * Dynamic API URL
   *
   * @param IHttpParams data
   * @returns string
   */
  getApiUrl(data: API.IHttpParams): string {
    return data.url
      ? data.url
      : data.apiUrl
        ? data.apiUrl.concat(data.api ?? '')
        : this.apiUrl.concat(data.api ?? '')
  }

  /**
   * @description
   * Removed data with undefined value from object.
   *
   * @param object data
   * @returns HttpParams | null
   */
  objToHttpParams(obj: Record<string, unknown>): HttpParams | null {
    let params: HttpParams = new HttpParams();
    // console.log('obj:', obj)
    try {
      Object.entries(obj).forEach(
        ([key, value]): void => {
          if (key && value!==undefined) params = params.append(
            String(key),
            String(value) || value as string
          )
        }
      );
    }
    catch(e) {
      console.error(`@toHttpParams:${e}`);
      return null;
    }

    return params;
  }
}
